import Header from "../components/Header";
import "../assets/css/PrivacyPolicy.css"


export default function PrivacyPolicy() {
    return (
        <>
            <Header/>
            <div className="container section privacy_policy">

                <h1>حریم خصوصی</h1>
                <h2>۱-مقدمه</h2>

                <p>
                    استدیوی مدریک با احترام به حقوق کاربران، خود را متعهد می‌داند که از اطلاعات شخصی شما محافظت کرده و
                    شفافیت کامل در مورد نحوه جمع‌آوری، استفاده و نگهداری داده‌ها داشته باشد. هدف از این سیاست، توضیح
                    روش‌هایی است که ما از آن طریق اطلاعات شما را جمع‌آوری، استفاده، ذخیره و محافظت می‌کنیم.
                </p>

                <h2>۲- اطلاعاتی که جمع‌آوری می‌کنیم</h2>
                <h3>الف) اطلاعاتی که شما مستقیماً ارائه می‌دهید:</h3>
                <ul>
                    <li>نام، نام کاربری، ایمیل یا شماره تماس</li>
                    <li>اطلاعات حساب کاربری از جمله شناسه و رمز عبور</li>
                    <li>اطلاعاتی که در تماس با پشتیبانی یا رویدادها ارائه می‌کنید</li>
                </ul>

                <h3>ب) اطلاعاتی که به‌صورت خودکار جمع‌آوری می‌شود:</h3>
                <ul>
                    <li>شناسه دستگاه (Device ID)</li>
                    <li>اطلاعات نحوه استفاده از بازی‌ها (زمان، مراحل، امتیازات)</li>
                    <li>آدرس IP و داده‌های تحلیلی</li>
                </ul>

                <h3>ج) اطلاعات از سرویس‌های شخص ثالث:</h3>
                <p>
                    در صورت ورود با Google Play Games، Apple Game Center یا شبکه‌های اجتماعی، اطلاعات پایه طبق تنظیمات
                    همان
                    سرویس دریافت می‌شود.
                </p>

                <h2>۳- هدف از جمع‌آوری اطلاعات</h2>
                <ul>
                    <li>ارائه و بهبود بازی‌ها و خدمات</li>
                    <li>شخصی‌سازی تجربه کاربر</li>
                    <li>پاسخ به پشتیبانی</li>
                    <li>تحلیل رفتار کاربران</li>
                    <li>رعایت الزامات قانونی و جلوگیری از سوءاستفاده</li>
                </ul>

                <h2>۴- اشتراک‌گذاری اطلاعات</h2>
                <p>صرفاً در صورت الزام قانونی یا درخواست مراجع ذی‌صلاح. اطلاعات برای فروش یا تبلیغات هدفمند منتقل
                    نمی‌شود.</p>

                <h2>۵- امنیت داده‌ها</h2>
                <p>از روش‌های فنی و سازمانی مناسب استفاده می‌کنیم؛ با این حال هیچ سیستم ۱۰۰٪ ایمن نیست و کاربران نیز
                    باید از
                    حساب خود محافظت کنند.</p>

                <h2>۶- ذخیره و مدت نگهداری</h2>
                <ul>
                    <li>تا زمانی که حساب فعال است یا برای اهداف این سیاست لازم باشد.</li>
                    <li>در صورت حذف حساب/درخواست کاربر، داده‌ها حذف یا ناشناس‌سازی می‌شوند.</li>
                    <li>اطلاعات کاربران تا ۶ ماه در سرورها نگهداری خواهد شد.</li>
                </ul>

                <h2>۷- حقوق کاربران</h2>
                <ul>
                    <li>درخواست مشاهده/ویرایش/حذف اطلاعات</li>
                    <li>حذف حساب در هر زمان</li>
                </ul>

                <h2>۸- تغییرات</h2>
                <p>ممکن است سیاست به‌روزرسانی شود؛ تاریخ آخرین به‌روزرسانی در ابتدای سند درج می‌شود و ادامه استفاده
                    به‌منزله
                    پذیرش است.</p>

                <p>
                    🔒 جمع‌بندی: استدیوی مدریک متعهد به شفافیت، اعتماد و امنیت است و از اطلاعات کاربران محافظت می‌کند.
                </p>
            </div>
        </>
    );
}

 